import { Component, computed, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ClienteEncabezado } from "@shared/models/cliente/ClienteEncabezado";
import { IATAService } from "@management/iata-index/iata.service";
import { ConfiguracionIATA } from "@shared/models/cliente/configuracionIATA";
import { ClienteService } from '@cliente/cliente.service';
import { Aeroplanta } from '@shared/models/despacho/Aeroplanta';
import { ClienteConfiguracionIATA } from '@shared/models/cliente/clienteIataDTO';
import { Cuenta } from '@shared/models/cliente/Cuenta';
import { MessageService } from '@shell/message.service';
import { TipoCuenta } from '@shared/enums/tipoCuenta';

@Component({
  selector: 'app-iata-cuentas-detalle',
  templateUrl: './iata-cuentas-detalle.component.html',
  styleUrl: './iata-cuentas-detalle.component.scss'
})
export class IataCuentasDetalleComponent implements OnInit {

  @Input() agregarCuenta: boolean = false;
  @Input() editarCuenta: boolean = false;
  @Input() clienteNuevo: boolean = false;
  @Input() index: number;
  @Input() clienteIataArray: ClienteConfiguracionIATA[];

  aeroplantas: string[] = [];
  // Acceder a la señal compartida
  configuracionSeleccionada = this.iataService.configuracionSeleccionada;
  clientesCuenta: ClienteEncabezado[];
  listaCuentasAImputar: Cuenta[];
  listaCuentasSolicitantes: Cuenta[];
  cargandoCuentas: boolean;
  cargandoAeroplantas: boolean;
  @Input() aeroplantasDisponibles: Aeroplanta[];
  @Input() aeroplantasLista: Aeroplanta[];
  obteniendoCuentasImputar: boolean;
  guardandoNuevaConfiguracion: boolean;
  guardando: boolean;

  clientesIataForm = new UntypedFormGroup({
    razonSocialFormControl: new UntypedFormControl(null, Validators.required),
    cuentaSolicitanteFormControl: new UntypedFormControl(null, Validators.required),
    clienteImputarFormControl: new UntypedFormControl(null, Validators.required),
    cuentaImputarFormControl: new UntypedFormControl(null, Validators.required),
    aeroplantasFormControl: new UntypedFormControl(null, Validators.required)
  })
  constructor(public activeModal: NgbActiveModal,
    private clienteService: ClienteService,
    public iataService: IATAService,
    public messageService: MessageService) { }

  ngOnInit() {
    this.cuentaImputarFormControl.disable();
    this.clientesCuenta = this.iataService.clientes();
    if (this.clienteNuevo !== true) {
      this.actualizarValoresFormulario();
      this.setearCuentas();
      this.aeroplantasDisponibles = this.aeroplantasLista;
    }
  }

  setearCuentas() {
    this.cuentaSolicitanteFormControl.disable();
    this.cargandoCuentas = true;
    if (this.iataService.configuracionSeleccionada()) {
      this.clienteService.getClientePorDocumento(this.iataService.configuracionSeleccionada().clienteSolicitante.tipoDocumento, this.iataService.configuracionSeleccionada().clienteSolicitante.numeroDocumento).subscribe(cliente => {
        this.listaCuentasSolicitantes = cliente.cuentas;
        this.cargandoCuentas = false;
        this.cuentaSolicitanteFormControl.enable();
      });
    }
  }

  actualizarValoresFormulario() {
    const configuracion = this.configuracionSeleccionada()['configuracion']?.[this.index];
    if (configuracion) {
      this.clientesIataForm.patchValue({
        cuentaSolicitanteFormControl: configuracion.cuentaSolicitante || null,
        clienteImputarFormControl: configuracion.clienteImputar || null,
        cuentaImputarFormControl: this.listaCuentasAImputar?.find(c => c.id === configuracion.cuentaImputar?.id) || null
      });
      if (configuracion.aeroplantas)
        this.aeroplantas = [...configuracion.aeroplantas];
        this.selectClienteImputar( configuracion.cuentaImputar, true);
    } else {
      // Si no hay configuración para el índice actual, limpiar los valores
      this.clientesIataForm.reset();
    }
  }

  selectClienteImputar(event: any, flag?: boolean) {
    const clienteImputar = flag ? event : event.item;
    const clienteTipoDocumento = flag ? this.clienteImputarFormControl.value?.tipoDocumento : event?.item?.tipoDocumento;
    const clienteNroDocumento = flag ? this.clienteImputarFormControl.value?.numeroDocumento : event?.item?.numeroDocumento;
    if (typeof (clienteImputar) === 'object') {
      this.obteniendoCuentasImputar = true;
      this.cuentaImputarFormControl.setValue(null);
      this.cuentaImputarFormControl.disable();
      this.clienteService.getClientePorDocumento(clienteTipoDocumento, clienteNroDocumento).subscribe(cliente => {
        this.listaCuentasAImputar = cliente.cuentas;
        this.listaCuentasAImputar = this.listaCuentasAImputar.filter(c => c.tipoCuenta == TipoCuenta.CuentaCorriente);
        const cuentaASeleccionar = this.listaCuentasAImputar?.find(c => c.id == clienteImputar.id);
        this.cuentaImputarFormControl.setValue(cuentaASeleccionar ? cuentaASeleccionar : this.listaCuentasAImputar[0]);
        console.log(clienteImputar)
        this.cuentaImputarFormControl.enable();
        this.obteniendoCuentasImputar = false;
      }, () => {
        this.obteniendoCuentasImputar = false;
        this.cuentaImputarFormControl.enable();
      })
    }
  }

  containsString(searchValue: string, ...searchIn: string[]): boolean {
    const concat = searchIn.toString();
    return concat.toLowerCase().indexOf(searchValue.toLowerCase()) > -1
  }


  formatter = (x: { razonSocial: string }) => `${x.razonSocial}`;

  search = (text$: Observable<string>) => {
    return text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => {
        if (!this.clientesCuenta || term.length < 2) {
          return [];
        }

        const termLower = term.trim().toLowerCase();
        const configuracionesExistentes = this.iataService.getConfiguraciones() || [];

        return this.clientesCuenta
          .filter(v =>
            this.containsString(termLower, v.razonSocial, v.numeroDocumento) &&
            !configuracionesExistentes.some(config =>
              config.clienteSolicitante?.razonSocial?.trim().toLowerCase() === v.razonSocial?.trim().toLowerCase()
            )
          )
          .slice(0, 10);
      })
    );
  };


  searchImputar = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.clientesCuenta == null || term.length < 2 ? [] :
        this.clientesCuenta.filter(v => this.containsString(this.clienteImputarFormControl.value, v.razonSocial, v.numeroDocumento)).slice(0, 10))
    )


  compareCuentas(d1: any, d2: any): boolean {
    return d1 && d2 ? d1.id === d2.id : d1 === d2;
  }

  agregarAeroplanta() {
    const seleccionada = this.aeroplantasFormControl.value;
    if (seleccionada) {
      if (!this.aeroplantas.includes(seleccionada.codigoAeroplanta)) {
        this.aeroplantas.push(seleccionada.codigoAeroplanta);
        this.actualizarDropdownAeroplantas();
      }
      this.aeroplantasFormControl.setValue(null);
    }
  }

  actualizarDropdownAeroplantas() {
    if (this.aeroplantasLista) {
      this.aeroplantasDisponibles = this.aeroplantasLista.filter(aero =>
        !this.aeroplantas.includes(aero.codigoAeroplanta)
      );
    }
  }

  getNombreAeroplanta(aeroplantaCodigo) {
    const aeroplanta = this.aeroplantasLista?.find(a => a.codigoAeroplanta == aeroplantaCodigo);
    if(aeroplanta)return aeroplanta.nombre;
  }

  onEliminarAeroplanta(aeroplanta) {
    this.aeroplantas = this.aeroplantas.filter(p => p !== aeroplanta);
    this.actualizarDropdownAeroplantas();
  }

  //Validación de campos
  puedeGuardar() {
    if (this.clienteNuevo) {
      const cliente = this.razonSocial.value;
      const nombreRepetido = computed(() =>
        this.clienteIataArray.some(cli => cli.clienteSolicitante?.razonSocial.trim().toLowerCase() === cliente)
      );
      return !!cliente && cliente?.razonSocial?.trim().length > 0 && !nombreRepetido() && !this.guardandoNuevaConfiguracion; // Verifica que no sea null, undefined o vacío
    }
    else if (this.editarCuenta || this.agregarCuenta) {
      if (this.agregarCuenta && (!this.cuentaSolicitanteFormControl.value))
        return false;

      if (!!this.clienteImputarFormControl.value &&
        !!this.cuentaImputarFormControl.value &&
        this.aeroplantas.length > 0)
        return true;
    }
  }

  actualizarConfiguracionSeleccionada() {
    if (this.configuracionSeleccionada()) {
      // Actualizar la configuración correspondiente al índice actual
      this.configuracionSeleccionada().configuracion[this.index] = {
        cuentaSolicitante: this.cuentaSolicitanteFormControl.value,
        clienteImputar: this.clienteImputarFormControl.value,
        cuentaImputar: this.cuentaImputarFormControl.value,
        aeroplantas: this.aeroplantas
      };

      // Actualizar la señal con los nuevos valores
      this.iataService.setConfiguracion(this.configuracionSeleccionada());
      this.guardarConfiguracion(false);
    }
  }

  agregarNuevaCuenta() {
    if (this.configuracionSeleccionada()) {
      const nuevaConfiguracion: ConfiguracionIATA = {
        cuentaSolicitante: this.cuentaSolicitanteFormControl.value,
        clienteImputar: this.clienteImputarFormControl.value,
        cuentaImputar: this.cuentaImputarFormControl.value,
        aeroplantas: [...this.aeroplantas]
      };
      this.configuracionSeleccionada().configuracion.push(nuevaConfiguracion);
      this.iataService.setConfiguracion(this.configuracionSeleccionada());
      this.guardarConfiguracion(true);
    }
  }

  guardarConfiguracion(agrega) {
    this.guardando = true;
    this.clientesIataForm.disable();
    this.iataService.putCuentasConfiguracionIATA(this.configuracionSeleccionada()).subscribe(config => {
      this.messageService.showSuccessMessage('Cuenta guardada exitosamente.')
      this.guardando = false;
      this.clientesIataForm.enable();
      this.activeModal.close(config);
    }, (Error) => {
      this.messageService.showErrorMessage('Error al guardar: ' + Error.description);
      this.guardando = false;
      this.clientesIataForm.enable();
      if(agrega) this.configuracionSeleccionada().configuracion.pop();
      this.iataService.setConfiguracion(this.configuracionSeleccionada());
      this.activeModal.dismiss('Close clicked');
    })
  }

  agregarTodasAeroplanta() {
    this.aeroplantas = this.aeroplantasLista.map(a => a.codigoAeroplanta);
    this.actualizarDropdownAeroplantas();
  }

  agregarClienteNuevo() {
    const nuevaConfiguracion = new ClienteConfiguracionIATA();
    nuevaConfiguracion.clienteSolicitante = this.razonSocial.value;
    nuevaConfiguracion.configuracion = [];
    this.guardandoNuevaConfiguracion = true;
    this.iataService.postNuevaConfiguración(nuevaConfiguracion).subscribe(config => {
      this.messageService.showSuccessMessage('Se ha agregado correctamente la nueva configuración');
      this.guardandoNuevaConfiguracion = false;
      this.activeModal.close(config);
    }, () => {
      this.messageService.showErrorMessage('Ha habido un error al guardar la configuración');
      this.guardandoNuevaConfiguracion = false;
      this.activeModal.dismiss('Close clicked');
    });
  }

  onSubmit() {
    if (this.editarCuenta) {
      this.actualizarConfiguracionSeleccionada();
    } else if (this.agregarCuenta) {
      this.agregarNuevaCuenta();
    } else {
      this.agregarClienteNuevo();
    }
  }
  //Get and set
  get razonSocial() {
    return this.clientesIataForm.get('razonSocialFormControl');
  }
  get cuentaSolicitanteFormControl() {
    return this.clientesIataForm.get('cuentaSolicitanteFormControl');
  }
  get clienteImputarFormControl() {
    return this.clientesIataForm.get('clienteImputarFormControl');
  }
  get cuentaImputarFormControl() {
    return this.clientesIataForm.get('cuentaImputarFormControl');
  }
  get aeroplantasFormControl() {
    return this.clientesIataForm.get('aeroplantasFormControl');
  }
}
